import { Route } from '@angular/router';
import { getNavigationGroup } from '../../core/config/app-navigation';
import { pageAccessGuard } from '../../core/guards/page-access.guard';

const analiticaNavigation = getNavigationGroup('analitica');

const analiticaRouteLoaders = {
  rrhh: () => import('./pages/rrhh/rrhh.page').then((m) => m.RrhhPage),
  'ficha-medica': () =>
    import('./pages/ficha-medica/ficha-medica.page').then((m) => m.FichaMedicaPage),
  ordenes: () =>
    import('./pages/ordenes/analitica-ordenes.page').then((m) => m.AnaliticaOrdenesPage),
  facturacion: () =>
    import('./pages/facturacion/facturacion.page').then((m) => m.FacturacionPage),
};

export const analiticaRoutes: Route[] = analiticaNavigation.items.map((item) => {
  const loadComponent = analiticaRouteLoaders[item.key as keyof typeof analiticaRouteLoaders];

  if (!loadComponent) {
    throw new Error(`No loadComponent configured for analitica route "${item.key}".`);
  }

  return {
    path: item.path.replace(/^\//, ''),
    data: {
      pageKey: item.pageKey,
      title: item.title,
      description: item.description,
    },
    canActivate: [pageAccessGuard],
    loadComponent,
  };
});
